export default __webpack_public_path__ + "static/media/icons-menu.63e5268c.svg";